import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {civilityOptions, fonctionOptions,} from '../../../../../../shared/utils/data/etablissments-data';
import {CountryISO, PhoneNumberFormat, SearchCountryField,} from '@justin-s/ngx-intl-tel-input';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PersonsService} from "../../../../../../services/persons.service";
import {AuthService} from "../../../../../../services/auth.service";
import {FlagService} from "../../../../../../shared/services/flag.service";
import {FlagType} from "../../../../../../shared/utils/enums";

@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrl: './add-contact.component.scss',
})
export class AddContactComponent implements OnInit {
  preferredCountries: CountryISO[] = [CountryISO.France];
  form: FormGroup;
  loading = false;
  images: string[] = [];
  phoneMaxLength: number = 10;
  phoneNumber: string | undefined;
  constructor(
    public dialogRef: MatDialogRef<AddContactComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private personsService: PersonsService,
    private fb: FormBuilder,
    private auth: AuthService,
    private flag: FlagService,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      id: [null],
      civility: ['', Validators.required],
      firstName: ['', Validators.required],
      fonction: ['', Validators.required],
      lastName: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email]],
      numTel: ['', Validators.required],
      photo1: [''],
      photo2: ['']
    });
    if (this.data) {
      this.phoneNumber = this.data?.numTel;

      this.form.patchValue(this.data)
      if (this.data.photo1) {
        this.images.push(this.data.photo1)
      }
      if (this.data.photo2) {
        this.images.push(this.data.photo2)
      }
    }
  }

  // item.numTel = a?.numTel?.internationalNumber;

  addContact() {
    const numTel = this.form.get('numTel')?.value?.number.replace(/\s/g, '');
    this.loading = true;
    this.phoneNumber = numTel;
    const body = this.form.value;
    body.numTel = numTel;
    body.fullnamepersonnecontact = this.form.value.firstName+ ' ' + this.form.value.lastName
    body.fonctionpersonnecontact = this.form.value.fonction;
    this.personsService.addPerson(body, this.auth.id).subscribe({
      next: value => {
        this.loading = false
        this.dialogRef.close(true);
        this.flag.displayFlag(`Contact ${this.data ? 'modifié': 'ajouté'} avec succés !`, FlagType.success)
      },
      error: () => {
        this.loading = false
      }
    })
  }
  getImage(images: string[]) {
    const photot1 = this.form.get('photo1')
    photot1?.patchValue('')
    if (images[0]) {
      photot1?.patchValue(images[0])
    }
  }
  onInputChange(event: any) {
    const inputNumber = event?.number;

    if (!inputNumber) return;


     if (inputNumber.startsWith('0')) {
       this.phoneMaxLength = 10;
     } else {
         this.phoneMaxLength = 9;

    }
    if (inputNumber.length > this.phoneMaxLength) {
      this.phoneNumber = inputNumber.slice(0, this.phoneMaxLength);
      this.form.get('phone')?.setValue(this.phoneNumber);
    } else {
      this.phoneNumber = inputNumber;
    }
  }
  protected readonly SearchCountryField = SearchCountryField;
  protected readonly CountryISO = CountryISO;
  protected readonly civilityOptions = civilityOptions;
}
